import styled, { css } from 'styled-components';

type WrapperProps = {
  isFetching?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  max-width: 100%;
  width: 100%;
  height: 100%;
  /* overflow-x: scroll; */
  position: relative;

  ${props => props.isFetching && css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > span {
      color: var(--grey-100);
      margin-top: 1rem;
      font-family: Inter, sans-serif;
    }
  `}
`;

export const Table = styled.table`
  margin-top: 2rem;
  border-collapse: collapse;
  margin-bottom: auto;
  width: 100%;
  height: 100%;
  /* overflow-x: hidden; */
  font-family: Inter, sans-serif;
`;

export const THead = styled.thead``;

export const THeadRow = styled.tr`
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--grey-300);
  width: 100%;
`;

type THeadColumnProps = {
  width?: string;
}

export const THeadColumn = styled.th<THeadColumnProps>`
  text-align: start;
  padding-bottom: 1.1rem;

  padding-right: 1.5rem;

  button {
    justify-content: flex-start;
    align-items: center;
    display: flex;
    background: none;
    border: none;
    color: var(--grey-100);
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;

    min-width: 8rem !important;
    max-width: 20rem !important;
  }
`;

export const TableBody = styled.tbody`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: normal;
`;

export const Row = styled.tr`
  border-bottom: 1px solid var(--black-200);
  border-top: 1px solid var(--black-200);

  cursor: pointer;

  &:hover {
    > .action__wrapper {
      visibility: visible;
    }

    background-color: #131313;
  }
`;

export const Column = styled.td`
  height: 3.5rem;
  font-size: 1rem;
  line-height: 1rem;
  color: var(--white);  

  max-width: 250px;

  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;
`;

export type StatusBadgeVariant = 'active' | 'deactive' | 'warning';

type StatusBadgeProps = {
  isActive?: boolean;
  variant?: StatusBadgeVariant;
}

const statusBadgeVariant = (variant?: StatusBadgeVariant) => {
  switch(variant) {
    case 'active': 
      return css`
        width: 5.625rem;
        color: var(--green);
        background: rgba(71, 212, 68, 0.1);
      `
    case 'deactive':
      return css`
        width: 6.1875rem;
        color: var(--grey-100);
        background: rgba(184, 184, 184, 0.1);
      `
    case 'warning':
      return css`
        width: 8rem;
        color: var(--orange);
        background: rgba(214,166,6, 0.2)
      `
    default: 
      return css`
        width: 5.625rem;
        color: var(--green);
        background: rgba(71, 212, 68, 0.1);
      `
  }
}

export const StatusBadge = styled.div<StatusBadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;

  font-size: 0.875rem;
  line-height: 0.875rem;
  height: 2rem;
  
  border-radius: 6.25rem;

  ${props => statusBadgeVariant(props.variant)}

  /* ${props => props.isActive ? css`
    width: 5.625rem;
    color: var(--green);
    background: rgba(71, 212, 68, 0.1);
  ` : css`
    width: 6.1875rem;
    color: var(--grey-100);
    background: rgba(184, 184, 184, 0.1);
  `} */
`